<script>
import { isPc } from './utils';
const {
    rem: { rem }
} = window.FEGOUtils;
export default {
    name: 'img-swiper',
    data() {
        return {
            isPc: isPc(),
        };
    },
    props: {
        tpl: {},
        slideWidth: Number | String,
        slideHeight: Number | String,
        hasChangeSize: Boolean,
        slideSpace: Number,
        activeColor: String,
        inactiveColor: String,
        loop: Boolean,
        autoPlay: Boolean,
        centeredSlides: Boolean,
        autoPlayDelay: {
            type: Number,
            default: 3000
        },
    },
    computed: {
        slideSize() {
            return {
                '--slide-width': rem.str(this.slideWidth),
                '--slide-height': rem.str(this.slideHeight)
            };
        },
        cssProperties() {
            return {
                '--swiper-padding-left': this.isPc || this.centeredSlides ? 0 : '0.4rem',
                '--swiper-pagination-color': this.activeColor,
                '--swiper-pagination-bullet-inactive-color': this.inactiveColor
            };
        },
    },
    watch: {},
    methods: {
    },
    mounted() {
    }
};
</script>
